var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"image-wrapper"},[_c('img',{attrs:{"src":_vm.getSrc,"alt":"Company's image"}})])
}
var staticRenderFns = []

export { render, staticRenderFns }